/** Recognize a complete conversational farewell, not a finished CRM task.
 * Anchoring the whole current utterance preserves any appended work or question.
 * This reply makes no assertion about saved records and never closes the microphone.
 */
export function conversationClosingReply(currentHuman:unknown):string|null{
 if(typeof currentHuman!=='string'||!currentHuman.trim()||currentHuman.length>240||currentHuman.includes('?'))return null;
 const text=currentHuman.normalize('NFD').replace(/\p{M}/gu,'').toLocaleLowerCase('it').replace(/[.,!;:…"'“”«»]/gu,' ').replace(/\s+/gu,' ').trim();
 const courtesy='(?:grazie(?: mille)?|ok|perfetto|va bene)';
 const done='(?:per ora (?:ho finito|basta)|basta per ora|ci sentiamo(?: dopo| piu tardi)?|a presto|fermiamoci qui|possiamo fermarci qui)';
 const noMore='(?:non (?:creare|aggiungere|programmare) (?:altre attivita|altre task|altro|nulla|niente)|non (?:fare|salvare|modificare|inviare) (?:altro|nulla|niente)|non (?:inviare|mandare) (?:altri )?messaggi)';
 const pattern=new RegExp('^(?:'+courtesy+' ){0,3}'+done+'(?: '+courtesy+')?(?: '+noMore+'){0,2}(?: '+courtesy+')?$','u');
 return pattern.test(text)?'Va bene, a presto.':null;
}
